<micro-lookup domain="domain" obj="locations" url="/domain/locations" objectType="Location" [key]="locationId" [link]="link"></micro-lookup>
